module.exports = __webpack_public_path__ + "static/media/icon_view_behind.10867582.svg";